import type { KeyboardEvent } from 'react';

export interface ShortcutConfig {
  id: string;
  name: string;
  description: string;
  keys: string; // 显示用的字符串，如 "⌘+N"
  // 用于 hook 匹配的配置
  match: {
    key: string;
    code?: string; // 物理按键代码，用于解决 Mac Option 键输入特殊字符的问题
    metaKey?: boolean;
    ctrlKey?: boolean;
    shiftKey?: boolean;
    altKey?: boolean;
  };
}

export const SHORTCUTS: ShortcutConfig[] = [
  {
    id: 'NEW_PROJECT',
    name: '新建项目',
    description: '创建一个新项目',
    keys: 'Option + N',
    match: { key: 'n', code: 'KeyN', altKey: true },
  },
  {
    id: 'NEW_FOLDER',
    name: '新建文件夹',
    description: '创建一个新文件夹',
    keys: 'Option + Shift + N',
    match: { key: 'n', code: 'KeyN', altKey: true, shiftKey: true },
  },
  {
    id: 'TOGGLE_PROJECT_PANEL',
    name: '切换项目面板',
    description: '打开或关闭左侧项目列表',
    keys: 'Option + B',
    match: { key: 'b', code: 'KeyB', altKey: true },
  },
  {
    id: 'TOGGLE_RESOURCES_PANEL',
    name: '切换素材面板',
    description: '打开或关闭素材库面板',
    keys: 'Option + Shift + B',
    match: { key: 'b', code: 'KeyB', altKey: true, shiftKey: true },
  },
  {
    id: 'TOGGLE_STORYBOARD_BOARD',
    name: '切换时间轴',
    description: '展开或折叠时间轴面板',
    keys: 'Option + J',
    match: { key: 'j', code: 'KeyJ', altKey: true },
  },
  {
    id: 'TOGGLE_PROPERTIES_PANEL',
    name: '切换属性面板',
    description: '展开或折叠右侧属性面板',
    keys: 'Option + R',
    match: { key: 'r', code: 'KeyR', altKey: true },
  },
];

// Helper to check if event matches config
export const isShortcutPressed = (event: KeyboardEvent | globalThis.KeyboardEvent, config: ShortcutConfig) => {
  const { key, code, metaKey, ctrlKey, shiftKey, altKey } = config.match;

  // 优先匹配物理按键 code (解决 Mac Option 键输入特殊字符问题)
  const keyMatches = code 
    ? event.code === code 
    : (event.key.toLowerCase() === key.toLowerCase());

  return (
    keyMatches &&
    !!event.metaKey === !!metaKey &&
    !!event.ctrlKey === !!ctrlKey &&
    !!event.shiftKey === !!shiftKey &&
    !!event.altKey === !!altKey
  );
};
